import React from 'react';

// local imports
import * as S from './styles';

export type InformationBoxProps = {
  text: string;
  className?: string;
};

export const InformationBox = ({ text, className }: InformationBoxProps) => {
  return (
    <S.Wrapper className={className}>
      <S.IconWrapper>
        <S.Icon />
      </S.IconWrapper>
      {text}
    </S.Wrapper>
  );
};

export default InformationBox;
